import { balanceQueryKeys as e } from "./useBalanceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { paymentsApi as n } from "@maat/api-payments";
//#region src/balance/useBalanceQuery.ts
var r = (r) => t({
	queryKey: e.forWorkspace(r),
	queryFn: () => n.getWorkspaceBalance(),
	enabled: !!r
});
//#endregion
export { r as useBalanceQuery };
